import React from 'react';
import {Grid} from "@mui/material";


function ProductHistoryHeader(props) {
    return (
        <Grid container alignItems="center" sx={{py: 1, fontWeight: 'bold'}}>
            <Grid item xs={3}>商品名</Grid>
            <Grid item xs={2.5}>産地</Grid>
            {/*<Grid item xs={1}>発注種別</Grid>*/}
            <Grid item xs={2}>規格</Grid>
            <Grid item xs={1.5}>重量</Grid>
            <Grid item xs={1}>単位</Grid>
            <Grid item xs={1.5}>操作</Grid>
            <Grid item xs={0.5}></Grid> {/* Checkbox column */}
        </Grid>
    );
}

export default ProductHistoryHeader;
